<div class="max-w-3xl mx-auto px-4 py-6">
  <tt-alert
    variant="success"
    [label]="(textService.get('confirmation.title') | async) ?? ''"
    [message]="(textService.get('confirmation.text') | async) ?? ''"
  />
  <div class="text-center mt-4">
    <button class="btn btn-outline-secondary btn-sm" (click)="openReceipt()">
      Bon bekijken
    </button>
    <button class="btn btn-primary btn-sm ml-2" (click)="placeNewOrder()">
      {{ textService.get('confirmation.new_order') | async }}
    </button>
  </div>
</div>

@if (receipt()) {
  <tt-modal [dismissableOnBackdropClick]="true" (modalClose)="closeReceipt()">
    <span title>{{ receipt().table.name }}</span>

    <div body class="receipt">
      <div class="receipt__meta">{{ receipt().date }} &bull; {{ receipt().time }}</div>
      @if (receipt().customer.name) {
        <div class="receipt__meta">{{ receipt().customer.name }}</div>
      }
      @if (receipt().customer.email) {
        <div class="receipt__meta">{{ receipt().customer.email }}</div>
      }

      <div class="receipt__divider"></div>

      <div class="receipt__lines">
        @for (line of receipt().lines; track $index) {
          <div class="receipt__line">
            <div class="receipt__line-desc">
              <span class="receipt__line-qty">{{ line.quantity }}x</span>
              {{ line.description }}
            </div>
            @if (line.total > 0) {
              <div class="receipt__line-total">{{ line.total | ttcurrency }}</div>
            }
          </div>
          @for (option of line.options; track $index) {
            <div class="receipt__line receipt__line--option">
              <div class="receipt__line-desc">{{ option.description }}</div>
              @if (option.total > 0) {
                <div class="receipt__line-total">{{ option.total | ttcurrency }}</div>
              }
            </div>
          }
        }
      </div>

      <div class="receipt__divider"></div>

      <div class="receipt__total-row">
        <span>Totaal</span>
        <span>{{ receipt().total | ttcurrency }}</span>
      </div>

      <div class="receipt__payment">{{ receipt().payment_method }}</div>
    </div>

    <tt-button footer variant="secondary" (clicked)="closeReceipt()">Sluiten</tt-button>
    <tt-button footer variant="primary" (clicked)="downloadReceipt()">Opslaan</tt-button>
  </tt-modal>
}
